var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m10 10 5.09-5.09L10 10l5.09 5.09L10 10zm0 0L4.91 4.91 10 10l-5.09 5.09L10 10z","strokeWidth":"2","stroke":"currentColor","fill":"none","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Cross.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = Cross;

Cross.default = Cross;
